import { useEffect, useRef, useState } from "react";
import { Try } from "../../utils/genericUtils";
import ToggleSwitch from "../ToggleSwitch/toggle-switch";
import "./dynamic-form.css";

const columns = 1;
const rows = 1;

const defaultFieldProps = {
  id: "fieldId",
  name: "fieldName",
  type: "number | text | password | date | email | bool | select",
  hoverText: "",
  maxLen: 100,
  placeholder: "placholder",
  value: "",
  defaultValue: "",
  disabled: false,
  selectOptions: [{ key: "", value: "" }],
  validationFunc: async (id, e, setError) => {},
  onChange: (e) => {},
};

const defaultFormProps = {
  //x,y
  id: "form-id",
  layout: [columns, rows],
  fields: [defaultFieldProps],
};

export default function DynamicForm(props = defaultFormProps) {
  var field_index = 0;

  /**
   * Dynamically Render the input box
   * @param {*} columnIndex
   * @param {*} rowIndex
   * @returns
   */
  function RenderField() {
    let field = props.fields[field_index];
    field_index++;

    if (field) {
      return (
        <div className="input-box">
          <label htmlFor={field.id}>{field.name}</label>
          <DynamicFormInput {...field} />
        </div>
      );
    }
  }

  function RenderLayout() {
    const render_rows = () => {
      let rows = props.layout[1];
      let r = [];
      for (let i = 0; i < rows; i++) {
        r.push(
          <div key={`dynamic-form-${props.id}-row-${i}`} className="dynamic-form-row">
            {RenderField()}
          </div>
        );
      }
      return r;
    };

    const render_cols = () => {
      let columns = props.layout[0];
      let cols = [];
      for (let i = 0; i < columns; i++) {
        cols.push(
          <div key={`dynamic-form-${props.id}-col-${i}`} className="dynamic-form-column" style={{ width: 100 / props.layout[0] - 2 + "%" }}>
            {render_rows()}
          </div>
        );
      }
      return cols;
    };

    return render_cols();
  }

  return (
    <form id={props.id} className="dynamic-form" action="none" onSubmit={(e) => e.preventDefault()}>
      {RenderLayout()}
    </form>
  );
}

export function DynamicFormInput(props = defaultFieldProps) {
  const [validationMessages, setValidationMessages] = useState({});
  const [value, setValue] = useState(props.value);
  const isEditing = useRef(false);

  useEffect(() => {
    if (!isEditing.current && value !== props.value) setValue(props.value);
  }, [validationMessages, props.value]);

  const set_err = (message) => {
    let _m = { ...validationMessages };
    if (message) _m[props.id] = message;
    else Try(() => delete _m[props.id]);
    setValidationMessages(_m);
  };

  const type = props.type;
  switch (type) {
    case "text":
    case "password":
    case "number":
    case "date":
    case "email":
    case "tel":
      return (
        <>
          <input
            id={props.id}
            type={type}
            placeholder={props.placeholder}
            value={value}
            title={props.hoverText ?? undefined}
            disabled={props.disabled}
            maxLength={props.maxLen}
            onChange={(e) => {
              Try(async () => {
                isEditing.current = true;
                setValue(e.target.value);
                await props.validationFunc(props.id, e, set_err, props.defaultValue);
                props.onChange(e);
                //edit delay
                setTimeout(() => (isEditing.current = false), 100);
              });
            }}
          />
          <p className="validation-message">{validationMessages[props.id] ? `*${validationMessages[props.id]}` : ""}</p>
        </>
      );
    case "select":
      return (
        <select onChange={(e) => Try(() => props.validationFunc(e))}>
          {props.selectOptions.map((o) => (
            <option value={o.value}>{o.key}</option>
          ))}
        </select>
      );
    case "bool":
      return <ToggleSwitch id={props.id} active={!!props.value ?? false} />;
  }
}
